import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { pageHead } from "@/lib/route-head";
const LearnMore = lazy(() => import("@/pages/LearnMore"));

export const Route = createFileRoute("/_public/about")({
  component: LearnMore,
  head: () =>
    pageHead({
      path: "/about",
      title: "About Amorette — Curated Dinners, Thoughtful Introductions",
      description:
        "Amorette brings people together in person through curated dinner experiences — romantic, social and professional — in beautiful settings across our launch cities.",
    }),
});
